export default {
  fleets: state => state.fleets,
  fleet: state => state.fleet,
  sortedFleets: state => {
    const fleets = [...state.fleets]
    fleets.sort((a, b) => {
      if (a.Name < b.Name) return -1
      if (a.Name > b.Name) return 1
      return 0
    })
    return fleets
  },
  currentFleetId: state => Number(state.currentFleetId),
  availabilityInfo: state => state.availabilityInfo,
  fleetTypes: state => state.fleetTypes,
  fleetsLoaded: state => state.fleetsLoaded,
  filteredFleets: (state, getters) => term => {
    const q = (term || '').trim().toLowerCase()
    const base = getters.sortedFleets
    if (!q) return base
    return base.filter(wl => {
      const name = (wl.Name || '').toLowerCase()
      const region = (wl.Region || '').toLowerCase()
      const validIn = (wl.ValidIn || '').toLowerCase()
      return name.includes(q) || region.includes(q) || validIn.includes(q)
    })
  },
  pagedFleets: (state, getters) => term => {
    const list = getters.filteredFleets(term)
    const start = state.currentPage * state.pageSize
    return list.slice(start, start + state.pageSize)
  },

  totalPages: (state, getters) => term => {
    const total = getters.filteredFleets(term).length
    return Math.max(1, Math.ceil(total / state.pageSize))
  }
}
